/**
 * Debug Logger Component
 * Показывает логи прямо в приложении для отладки в Telegram
 */

import React, { useState, useEffect, useRef } from 'react';
import './DebugLogger.css';

const DebugLogger = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [logs, setLogs] = useState([]);
  const logAreaRef = useRef(null);

  useEffect(() => {
    // Перехватываем console методы
    const originalLog = console.log;
    const originalError = console.error;
    const originalWarn = console.warn;

    console.log = (...args) => {
      addLog('info', args.join(' '));
      originalLog.apply(console, args);
    };

    console.error = (...args) => {
      addLog('error', args.join(' '));
      originalError.apply(console, args);
    };

    console.warn = (...args) => {
      addLog('warning', args.join(' '));
      originalWarn.apply(console, args);
    };

    // Восстанавливаем оригинальные методы при размонтировании
    return () => {
      console.log = originalLog;
      console.error = originalError;
      console.warn = originalWarn;
    };
  }, []);

  useEffect(() => {
    // Автоскролл вниз при добавлении новых логов
    if (logAreaRef.current) {
      logAreaRef.current.scrollTop = logAreaRef.current.scrollHeight;
    }
  }, [logs]);

  const addLog = (level, message) => {
    const timestamp = new Date().toLocaleTimeString();
    setLogs(prev => [...prev.slice(-50), { // Храним последние 50 логов
      timestamp,
      level,
      message
    }]);
  };

  const toggleDebug = () => {
    setIsVisible(!isVisible);
  };

  const clearLogs = () => {
    setLogs([]);
  };

  return (
    <>
      <div className="debug-toggle" onClick={toggleDebug}>
        🐛 Логи {logs.length > 0 && `(${logs.length})`}
      </div>
      
      {isVisible && (
        <div className="debug-area" ref={logAreaRef}>
          <div className="debug-header">
            <span>Debug Logs</span>
            <button onClick={clearLogs} className="clear-btn">Очистить</button>
          </div>
          {logs.length === 0 ? (
            <div className="log-entry log-info">Нет логов</div>
          ) : (
            logs.map((log, index) => (
              <div key={index} className={`log-entry log-${log.level}`}>
                [{log.timestamp}] {log.message}
              </div>
            ))
          )}
        </div>
      )}
    </>
  );
};

export default DebugLogger;

